import {Component, Input} from '@angular/core';
import {RouterLink} from "@angular/router";
import {NgTemplateOutlet} from "@angular/common";

@Component({
    selector: 'app-link',
    imports: [
        RouterLink,
        NgTemplateOutlet
    ],
    templateUrl: './link.component.html',
    styleUrl: './link.component.scss'
})
export class LinkComponent {

  @Input() public href: string = '';
  @Input() public target: string = '_self';
  @Input() public style: string = '';
  @Input() public title: string = '';
  @Input() public active: boolean = false;


  public onClick(): boolean {
    return false;
  }
}
